<div style="max-width: 800px">
  <div mat-dialog-content>
    <lemon-dialog-header> Päätä sopimuskausi </lemon-dialog-header>

    <!-- <p *ngIf="kausi.sopimusAllekirjoitettu else notSignedYet">Sopimuskausi on alkanut {{ kausi.alkaa | lokaalipvm | async }} ja sopimus allekirjoitettiin {{ kausi.sopimusAllekirjoitettu | lokaalipvm | async }}.</p>
    <ng-template #notSignedYet>
      <p>Sopimuskausi on alkanut {{ kausi.alkaa | lokaalipvm | async }}, mutta sopimusta ei ole vielä allekirjoitettu.</p>
    </ng-template>

    <p>Asiakas voi maksaa palkkoja ja lähettää laskuja vielä päättymispäivän ajan.</p> -->

    <!-- <p *ngIf="!kausi.loppuu">Milloin yhteistyö asiakkaan kanssa päättyy?</p> -->

    <div style="margin-left: 10px; margin-right: 10px">
      <div style="display: flex">
        <mat-form-field style="width: 300px; margin-right: 10px">
          <mat-label>Sopimus päättyy</mat-label>
          <input type="text" [matDatepickerFilter]="vainKuunViimeinenFilter" [max]="maksimiLoppuuPaivamaara" [min]="minimiLoppuuPaivamaara" [matDatepicker]="pickerLoppuu" [formField]="sopimuskausiLomake.loppuu" matInput data-lpignore="true" />
          <mat-datepicker-toggle matSuffix [for]="pickerLoppuu"></mat-datepicker-toggle>
          @if (naytetaankoVirhe(sopimuskausiLomake.loppuu, 'required')) {
            <mat-error> Päättymispäivä puuttuu </mat-error>
          }
          @if (naytetaankoVirhe(sopimuskausiLomake.loppuu, 'edellinen')) {
            <mat-error> Kausi ei voi loppua seuraavan alkamisen jälkeen. </mat-error>
          }
          @if (naytetaankoVirhe(sopimuskausiLomake.loppuu, 'min')) {
            <mat-error> Sopimuskauden on alettava alkamisen jälkeen. </mat-error>
          }
          @if (naytetaankoVirhe(sopimuskausiLomake.loppuu, 'matDatepickerMin')) {
            <mat-error> Uusi muutos voi alkaa aikaisintaan ensi kuussa. </mat-error>
          }
          @if (naytetaankoVirhe(sopimuskausiLomake.loppuu, 'loppuuSuurempiKuinAlkaa')) {
            <mat-error> Päivämäärä on oltava alkamisen jälkeen. </mat-error>
          }
          @if (naytetaankoVirhe(sopimuskausiLomake.loppuu, 'kuunViimeinen')) {
            <mat-error> Päivämäärä on oltava kuukauden viimeinen päivä. </mat-error>
          }
          @if (naytetaankoVirhe(sopimuskausiLomake.loppuu, 'hinnanOnMenneisyydessaOltavaNolla')) {
            <mat-error> Kuukaudesta on lähtenyt lasku, valitse toinen päivä. </mat-error>
          }
          <mat-datepicker #pickerLoppuu></mat-datepicker>
        </mat-form-field>
        <mat-checkbox style="scale: 0.8" [formField]="sopimuskausiLomake.salliMikaTahansaPaattymisPvm"> Salli mikä tahansa päättymispäivämäärä </mat-checkbox>
      </div>
      <div>
        <mat-form-field>
          <mat-label>Päättymisen syy</mat-label>
          <mat-select [formField]="sopimuskausiLomake.syy" [compareWith]="compareSyyt">
            @for (syy of kaikkiValittavatSyyt; track syy) {
              <mat-option [value]="syy">
                {{ syy.nimi }}
              </mat-option>
            }
          </mat-select>
          @if (naytetaankoVirhe(sopimuskausiLomake.syy, 'required')) {
            <mat-error>
              {{ 'lasku.validation.maa.required' | translate | async }}
            </mat-error>
          }
        </mat-form-field>
      </div>

      @if (irtisanominenMahdollistaAikaisintaanPaivamaaraObservable | async; as pvm) {
        <div style="margin: 1em; font-weight: bold">Irtisanomisajan mukaan sopimus voi päättyä aikaisintaan {{ pvm | lokaalipvm | async }}. Huomaathan, että irtisanomisajasta voidaan poiketa vain painavalla syyllä.</div>
      }

      <div style="padding-top: 25px">
        <mat-form-field>
          <mat-label>Lisätiedot</mat-label>
          <input type="text" [formField]="sopimuskausiLomake.lisatiedot" matInput data-lpignore="true" />
          @if (valittuSyy?.lisatiedotVinkki) {
            <mat-hint>{{ valittuSyy?.lisatiedotVinkki || null }}</mat-hint>
          }
          @if (naytetaankoVirhe(sopimuskausiLomake.lisatiedot, 'required')) {
            <mat-error> Lisätiedot puuttuvat </mat-error>
          }
        </mat-form-field>
      </div>
      @if (!onkoPurku) {
        <div style="padding-top: 25px">
          <mat-form-field style="max-width: 300px">
            <mat-label>Tositteiden toimitus loppuu</mat-label>
            <input type="text" [min]="minimiTositteetLoppuuPaivamaara" [matDatepicker]="pickerTositteetLoppuu" [formField]="sopimuskausiLomake.tositteetLoppuu" matInput data-lpignore="true" />
            <mat-datepicker-toggle matSuffix [for]="pickerTositteetLoppuu"></mat-datepicker-toggle>
            @if (naytetaankoVirhe(sopimuskausiLomake.tositteetLoppuu, 'required')) {
              <mat-error> Tositteiden loppumispäivä puuttuu </mat-error>
            }
            @if (naytetaankoVirhe(sopimuskausiLomake.tositteetLoppuu, 'matDatepickerMin') || naytetaankoVirhe(sopimuskausiLomake.tositteetLoppuu, 'tositteetSuurempiKuinLoppuu')) {
              <mat-error> Tositteiden toimittamisen on loputtava sopimuksen loppumisen jälkeen </mat-error>
            }
            <mat-datepicker #pickerTositteetLoppuu></mat-datepicker>
          </mat-form-field>
        </div>
      }
      <div style="padding-top: 25px" class="gray-text">
        @if (!onkoPurku) {
          <div>
            <p>Sopimuskausi päättyy {{ kausi.loppuu | lokaalipvm | async }}. Asiakkaan Lemonaid-tunnukset suljetaan {{ kausi.loppuu | lokaalipvm | async }} lukuun ottamatta aineiston toimitusta joka on auki {{ kausi.tositteidenToimitusLoppuu | lokaalipvm | async }} saakka (päivän loppuun asti).</p>
            Asiakkaalle lähetetään seuraavat sähköpostit automaattisesti:
            <div style="padding-left: 10px"><mat-checkbox [formField]="sopimuskausiLomake.lahetaPaattymassa"></mat-checkbox> {{ sopimusPaattyyPianEmailDate | lokaalipvm | async }} Sopimuksesi päättyy pian</div>
            <div style="padding-left: 10px"><mat-checkbox [formField]="sopimuskausiLomake.lahetaPaattynyt"></mat-checkbox> {{ sopimusOnPaattynytEmailDate | lokaalipvm | async }} Sopimuksesi on päättynyt</div>
          </div>
        }

        @if (onkoPurku) {
          <div>
            <p>Sopimuskausi päättyy {{ kausi.loppuu | lokaalipvm | async }}. Asiakkaan Lemonaid-tunnukset suljetaan {{ kausi.loppuu | lokaalipvm | async }} myös aineiston toimittamisen osalta.</p>
            Purkutilanteessa asiakkaalle ei lähetetä automaattisia sähköposteja.
          </div>
        }
        <!-- Asiakkaalle lähetetään sähköpostiviesti sopimuksen päättämisestä , jossa kerrotaan milloin eri ominaisuuksien käyttö päättyy.</p>

      <p>Palvelut päättyvä (viimeinen päivä jolloin vielä voi käyttää)</p>
      <ul>
        <li>Laskutus </li>
        <li>Palkkojen maksu Lemonaidissa {{ kausi.loppuu | lokaalipvm | async }}</li>
        <li>Tositteiden toimitus </li>
      </ul> -->
      </div>
    </div>
  </div>

  <div mat-dialog-actions style="padding-left: 0; padding-right: 0">
    <app-secondary-button mat-dialog-close actionId="Sopimuskauden päättäminen: Peruuta ja sulje dialog">Peruuta</app-secondary-button>
    <app-primary-button (click)="tallenna()" actionId="Sopimuskauden päättäminen, tallenna tiedot" [actionContext]="[sopimuskausiLomake().value()]">Tallenna</app-primary-button>
  </div>

  @if (onkoLaskujenVastaanottoPaallaObservable | async) {
    <div class="red-text" style="text-align: center; padding: 0 3em 30px 3em">
      <p>Huom! Asiakkaalla on laskujen vastaanotto käytössä. Laskujen vastaanotto kytketään pois päältä sopimuksen päättyessä. Käy asiakkaan kanssa asia läpi, jotta tämä ei tule yllätyksenä.</p>
      <p>Asiakkaan tulisi avata uusi sähköisten laskujen vastaanotto-osoite toiselle palveluntarjoajalle ja ilmoittaa osoite kaikille toimittajilleen tai ilmoittaa kaikille toimittajille vaihtoehtoinen laskujen toimitustapa. <b>Päättymisen jälkeen osoitteeseen tulevat laskut menetetään.</b></p>
    </div>
  }
</div>
